export default __webpack_public_path__ + "static/media/client_vendor_number_import_template.37cb04f7.csv";